import React from 'react'
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next'

import './index.less'
import './mobile.less'

import Layout from '@/components/Layout'
import ContentHeader from '@/components/ContentHeader'

export default function AboutUs() {
  const {t} = useTranslation()
  
  const commonState = useSelector(state => state.common)
  const rootClassName = commonState.isMobile ? 'about-us-mobile-container' : 'about-us-container'
  
  return (
    <Layout>
      <div className={rootClassName}>
        <ContentHeader
          className={'home-header-container'}
          des={t('')}
          title={t('ABOUT US')}
          title2={t('')}
        />
        <div className={'about-us-content-container'}>
          <div>
            In 2001, Hin Fat Hung, an immigrant from Hong Kong, founded Chun Yuen Trading Co. (USA), Inc because he saw a growing Asian migrant population in the US but not many Asian products available.  So, he spent the last 20+ years sourcing and importing various products from Asia. 
          </div>
          <div>
            Today, Chun Yuen Trading carries over 400+ Asian products.  In addition to sourcing various products from Asia, CYT also carries their own brands such as CB and AH Hung.  Under the CB brand, we have instant mix coffee and tea, and dried foods.   For the AH Hung brand, we have the seasoning and sauces for hot pot and dishes.  Finally, we are also the distributor for the Super and Eagle Brand products.  Super brand, a Keurig Dr Pepper product from Singapore, includes instant mixed coffee and tea.  Eagle brand products include various medicated oil products.
          </div>
          <div>
            <div className={'about-us-content-list-item-container'}>
              Chun Yuen Trading distributes to hundreds of Asian retailers like HMart, Tawa Ranch 99, T&T, independent supermarkets, and pharmacies across the west and mid west coasts.  If you are looking for the nearest supermarket location with our products, contact us and we will do our best to assist in locating it for you!  
            </div>
          </div>
        </div>
        
        <ContentHeader
          className={'home-header-container'}
          des={t('')}
          title={t('CONTACT US')}
          title2={t('')}
        />
        <div className={'about-us-content-container'}>
          <div className={'company-info'}>
            <div>
              <span className={'label'}>{t('Office Address')}: </span>
              10922 Klingerman Street, Suite #3, S El Monte, CA 91733
            </div>
            <div>
              <span className={'label'}>{t('Working Hours')}: </span>
              {t('Monday - Friday')} {t('8:30am - 4:00pm')} PST
            </div>
            <div>
              <span className={'label'}>{t('Email')}: </span>
              chunyuentradinginc@hotmail.com
            </div>
            <div>
              <span className={'label'}>{t('Phone')}: </span>
              626-454-3233
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
